import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { useI18n } from "@/lib/i18n";

export default function Account() {
  const { user, loading } = useAuth();
  const { t } = useI18n();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (user) {
      api.get("/orders/me").then((r) => setOrders(r.data)).catch(() => {});
    }
  }, [user]);

  if (loading) return <div className="pt-40 text-center font-mono-label text-xs">LOADING…</div>;
  if (!user) return <Navigate to="/login" />;

  return (
    <div data-testid="account-page" className="pt-32 pb-24 bg-[#F7F7F6] min-h-screen">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <p className="font-mono-label text-[11px] text-neutral-500 mb-8">[ ACCOUNT ]</p>
        <h1 className="font-serif-display font-light text-5xl md:text-6xl mb-4">{t("account_hello")},</h1>
        <p className="font-serif-display italic text-3xl text-neutral-500 mb-16">{user.name}.</p>

        <h2 className="font-mono-label text-[11px] text-neutral-500 mb-4">[ {t("account_orders").toUpperCase()} ]</h2>
        {orders.length === 0 ? (
          <div className="border border-neutral-300 bg-white p-10 text-center">
            <p className="text-neutral-600">No orders yet.</p>
          </div>
        ) : (
          <div className="border-t border-neutral-300">
            {orders.map((o) => (
              <div key={o.id} data-testid={`order-${o.id}`} className="border-b border-neutral-300 py-6 grid grid-cols-12 gap-4 items-center">
                <div className="col-span-3 font-mono-label text-[10px] text-neutral-500">#{o.id.slice(0, 8).toUpperCase()}</div>
                <div className="col-span-4">
                  {o.items?.map((it, i) => (
                    <p key={i} className="text-sm">{it.name} × {it.quantity}</p>
                  ))}
                </div>
                <div className="col-span-2 font-mono-label text-[10px]">
                  <span className={`px-2 py-1 border ${o.status === "paid" ? "border-black bg-black text-[#F7F7F6]" : "border-neutral-300"}`}>{o.status.toUpperCase()}</span>
                </div>
                <div className="col-span-2 text-sm text-neutral-500">{new Date(o.created_at).toLocaleDateString()}</div>
                <div className="col-span-1 text-right font-serif-display text-xl">€{Number(o.total).toFixed(2)}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
